// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3HLi9","left":"InfoRow_left__38FE-"};